/**
 * isTouchDevice — indica si el dispositivo tiene pantalla táctil.
 *
 * Se evalúa en cada llamada (no a nivel de módulo) para que los tests puedan forzar cualquiera de las
 * dos señales (`ontouchstart` en `globalThis` o `navigator.maxTouchPoints`) sin recargar el módulo.
 *
 * Limitación conocida: los portátiles con pantalla táctil también cuentan como táctiles.
 */
export default function isTouchDevice(): boolean {
  return 'ontouchstart' in globalThis || (globalThis.navigator?.maxTouchPoints ?? 0) > 0;
}
